<template>
  <div class="mainview">
    <iframe :src="url" ref="car" class="car" @touchstart="console.log('down')" @mousedown="this.$emit('down')"></iframe>
  </div>
</template>

<script>
  require('../js/WebglMessageEvent')
  export default {
    name: "CarMainView",
    data() {
      return {
        url: '',
        isExterior: true,
        carseries_id:getConfigure("carVersion").cbbCarSeriesId
      }
    },
    methods: {
      onMessage(message) {
        var info = {
          dynamic: {
            carseries_id: this.carseries_id,
          }
        }
        message = message.data;
        if (message == undefined || message.type != "webgl")
          return;
        switch (message.code) {
          case 201:
            this.$emit('progess', message.data.progess);
            break;
          case 202:
            this.$emit('success');
            break;
          case 801:
            this.$emit('outside_'+cartype.replace('-','')+'carpoint_click');
            break;
          case 902:
            this.$emit('down');
            break;
          case 903:
            this.$emit('up');
            break;
          case 301:
            var name = message.data.split('|')[2];
            this.$emit('showMedia',name);
            break;
          case 311:
            var name = message.data.split('|')[2];
            this.$emit('clickMenu',name);
            break;
          case 904:
            track("dn_web-20210421172811-od01-{carseries_id}",info);
            break;
          case 905:
            track("dn_web-20210421172811-id02-{carseries_id}",info);
            break;
          case 906:
            track("dn_web-20210421172811-od01-{carseries_id}",info);
            break;
        }
      },
      setExteriorColor(colorId) {
        this.isExterior = true;
        WebglMessageEvent.SHOW_EXTERIOR.data.colorId = colorId;
        this.postMessage(WebglMessageEvent.SHOW_EXTERIOR);
      },
      setVersion(version, type = 0) {
        WebglMessageEvent.SHOW_EXTERIOR.data.version = version;
        WebglMessageEvent.SHOW_INTERIOR.data.version = version;
        if (type == 0) {
          this.postMessage(WebglMessageEvent.SHOW_EXTERIOR);
        } else {

          this.postMessage(WebglMessageEvent.SHOW_INTERIOR);
        }
      },
      setInsideColor(colorId, version = null) {
        this.isExterior = false;
        WebglMessageEvent.SHOW_INTERIOR.data.id = colorId;
        if (version) {
          WebglMessageEvent.SHOW_INTERIOR.data.version = version;
        }
        this.postMessage(WebglMessageEvent.SHOW_INTERIOR);
      },
      showMarker(b) {
        WebglMessageEvent.SHOW_MARKET.data = b;
        this.postMessage(WebglMessageEvent.SHOW_MARKET);
      },
      postMessage(data) {
        if (data.funcName == "showExterior") {
          this.isExterior = true;
        } else if (data.funcName == "showInterior") {
          this.isExterior = false;
        }

        this.$refs['car'].contentWindow.postMessage(data, '*');
      },
      onBlur(evt){
        WebglMessageEvent.STOP.data = true;
        this.postMessage(WebglMessageEvent.STOP);
      },
      onFocus(evt){
        WebglMessageEvent.STOP.data = false;
        this.postMessage(WebglMessageEvent.STOP);
      },

    },
    mounted() {
      window.addEventListener('message',this.onMessage);
      if(UrlValue('car')=="xtrail"){
        this.url = window.path + "static/xtrail/webgl/webgl.html?car=xtrail&loadtype=zip";
      }
      else{
        this.url = window.path + "webgl.html?car=" + UrlValue('car')+"&loadtype=zip";
      }
      window.addEventListener('blur',this.onBlur);
      window.addEventListener('focus',this.onFocus);
    },
    destroyed() {
      window.removeEventListener('message',this.onMessage);
      window.removeEventListener('blur',this.onBlur);
      window.removeEventListener('focus',this.onFocus);
    }
  }
</script>

<style scoped lang="scss">
  .mainview {
    width: 100%;
    height: 100%;

    .car {
      width: 100%;
      height: 100%;
      border: none;
    }
  }
</style>
